// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Components
import { WebpSearchInput } from "components/WebpSearchInput";

type WebpDropdownProps = {
    id?: string;
    isOpened?: boolean;
    showSearch?: boolean;
};

export const WebpDropdown: FunctionComponent<WebpDropdownProps> = ({ id, isOpened = false, showSearch = false, children }) => {
    return (
        <Container className="webp-dropdown" isOpen={isOpened}>
            <div className="dropdown">
                {showSearch && <WebpSearchInput hasBorder={false} id={id} />}

                {children}
            </div>
        </Container>
    );
};
